import React from 'react';
import { useLoaderData } from 'react-router-dom';
import SinglePost from '../SinglePost/SinglePost';


const Post = () => {
     const posts = useLoaderData();
    return (
        <div>
            <h1>this is post page</h1>
            {
                posts.map(post => <SinglePost
                key = {post.id}
                post = {post}
                ></SinglePost>)
            }
        </div>
    );
};

export default Post;